export const fileQueryKeys = {
  base: ['file'],
  file: (tenantID: string | undefined | null, id: string | undefined | null) => [
    ...fileQueryKeys.base,
    'detail',
    tenantID,
    id,
  ],
  filesForHousehold: (householdID: string | undefined | null) => [...fileQueryKeys.base, 'household', householdID],
};
